/* ==============================================
   main-product-custom.js
   ============================================== */
document.addEventListener('DOMContentLoaded', function () {

  /* ─── 元素引用 ─────────────────────────────── */
  var mainImg      = document.querySelector('.cpc-main-img');
  var thumbs       = document.querySelectorAll('.cpc-thumb');
  var qtyInput     = document.querySelector('.cpc-qty-input');
  var priceEl      = document.getElementById('cpc-price');
  var compareEl    = document.getElementById('cpc-price-compare');
  var atcBtn       = document.querySelector('.cpc-btn-atc');
  var buyNowBtn    = document.querySelector('.cpc-btn-buynow');
  var idInput      = document.querySelector('input[name="id"]');
  var selectWraps  = document.querySelectorAll('.cpc-select-wrap');
  var specsAcc     = document.querySelector('.cpc-specs-accordion');

  /* ─── 价格格式化 ────────────────────────────── */
  function formatMoney(cents) {
    if (cents === null || cents === undefined) return '';
    var fmt = window.__cpcMoneyFormat__ || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    // 去掉尾部 .00（可选，保留两位小数更标准）
    return fmt
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.floor(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  /* ─── 更新价格显示（含数量倍乘） ───────────── */
  function updatePrice(variantPrice, variantCompare) {
    var qty = parseInt(qtyInput ? qtyInput.value : 1) || 1;

    if (priceEl) {
      priceEl.textContent = formatMoney(variantPrice * qty);
      priceEl.dataset.basePrice = variantPrice;
    }

    if (compareEl) {
      if (variantCompare && variantCompare > variantPrice) {
        compareEl.textContent   = formatMoney(variantCompare * qty);
        compareEl.dataset.baseCompare = variantCompare;
        compareEl.style.display = 'inline';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }

  /* ─── 数量变化时同步更新价格 ────────────────── */
  if (qtyInput) {
    qtyInput.addEventListener('input', function () {
      var basePrice   = parseInt(priceEl ? priceEl.dataset.basePrice : 0) || 0;
      var baseCompare = parseInt(compareEl ? compareEl.dataset.baseCompare : 0) || 0;
      updatePrice(basePrice, baseCompare);
    });
  }

  /* ─── 数量加减按钮 ──────────────────────────── */
  var qtyMinus = document.querySelector('.cpc-qty-minus');
  var qtyPlus  = document.querySelector('.cpc-qty-plus');

  if (qtyMinus) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value) || 1;
      if (v > 1) {
        qtyInput.value = v - 1;
        qtyInput.dispatchEvent(new Event('input'));
      }
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
      qtyInput.dispatchEvent(new Event('input'));
    });
  }

  /* ─── 缩略图切换主图 ────────────────────────── */
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      thumbs.forEach(function (b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');
      if (mainImg && this.dataset.full) {
        mainImg.src    = this.dataset.full;
        mainImg.srcset = '';
      }
    });
  });

  /* ─── FAQ 手风琴 ────────────────────────────── */
  document.querySelectorAll('.cpc-faq-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item     = this.closest('.cpc-faq-item');
      var isOpen   = item.classList.toggle('is-open');
      this.setAttribute('aria-expanded', isOpen);
    });
  });

  /* ─── 规格手风琴 ────────────────────────────── */
  if (specsAcc) {
    var specsTrigger = specsAcc.querySelector('.cpc-specs-trigger');
    if (specsTrigger) {
      specsTrigger.addEventListener('click', function () {
        specsAcc.classList.toggle('is-open');
      });
    }
  }

  /* ─── Flavor 下拉 ───────────────────────────── */
  selectWraps.forEach(function (wrap) {
    var trigger     = wrap.querySelector('.cpc-select-trigger');
    var options     = wrap.querySelectorAll('.cpc-select-option');
    var triggerText = wrap.querySelector('.cpc-select-trigger-text');
    var triggerImg  = wrap.querySelector('.cpc-select-trigger-img');
    var hidden      = wrap.querySelector('.cpc-select-hidden');

    if (!trigger) return;

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      selectWraps.forEach(function (w) { if (w !== wrap) w.classList.remove('is-open'); });
      wrap.classList.toggle('is-open');
    });

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        if (triggerText) triggerText.textContent = this.dataset.label;
        if (triggerImg && this.dataset.img) {
          triggerImg.src           = this.dataset.img;
          triggerImg.style.display = 'block';
        }
        if (hidden) hidden.value = this.dataset.value;
        wrap.classList.remove('is-open');
        updateVariant();
      });
    });
  });

  document.addEventListener('click', function () {
    selectWraps.forEach(function (w) { w.classList.remove('is-open'); });
  });

  /* ─── Serving 按钮 ──────────────────────────── */
  document.querySelectorAll('.cpc-serving-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (this.disabled) return;
      var section = this.closest('.cpc-variant-section');
      section.querySelectorAll('.cpc-serving-btn').forEach(function (b) {
        b.classList.remove('is-active');
      });
      this.classList.add('is-active');
      updateVariant();
    });
  });

  /* ─── 获取当前选中 options ──────────────────── */
  function getSelectedOptions() {
    var result = {};

    selectWraps.forEach(function (wrap) {
      var name     = wrap.dataset.optionName;
      var selected = wrap.querySelector('.cpc-select-option.is-selected');
      if (name && selected) result[name] = selected.dataset.value;
    });

    document.querySelectorAll('.cpc-variant-section').forEach(function (section) {
      var name      = section.dataset.optionName;
      var activeBtn = section.querySelector('.cpc-serving-btn.is-active');
      if (name && activeBtn) result[name] = activeBtn.dataset.value;
    });

    return result;
  }

  /* ─── 匹配 Variant ──────────────────────────── */
  function updateVariant() {
    var variants = window.__cpcVariants__ || [];
    var optNames = window.__cpcOptions__  || [];
    var mediaMap = window.__cpcMediaMap__ || {};
    var selected = getSelectedOptions();

    var matched = null;
    for (var i = 0; i < variants.length; i++) {
      var v   = variants[i];
      var hit = true;
      for (var j = 0; j < optNames.length; j++) {
        if (selected[optNames[j]] !== undefined &&
            selected[optNames[j]] !== v.options[j]) {
          hit = false;
          break;
        }
      }
      if (hit) { matched = v; break; }
    }

    if (!matched) {
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
      if (buyNowBtn) buyNowBtn.disabled = true;
      return;
    }

    /* 更新 hidden id */
    if (idInput) idInput.value = matched.id;

    /* 更新价格（含当前数量） */
    updatePrice(matched.price, matched.compare_at_price);

    /* 更新主图 */
    if (mainImg && mediaMap[matched.id]) {
      mainImg.src    = mediaMap[matched.id];
      mainImg.srcset = '';
      thumbs.forEach(function (btn) {
        btn.classList.remove('is-active');
        if (btn.dataset.full === mediaMap[matched.id]) {
          btn.classList.add('is-active');
        }
      });
    }

    /* 更新按钮 */
    var avail = matched.available;
    if (atcBtn) {
      atcBtn.disabled    = !avail;
      atcBtn.textContent = avail ? 'Add to Cart' : 'Sold Out';
    }
    if (buyNowBtn) buyNowBtn.disabled = !avail;

    /* 更新 URL */
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', matched.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  /* ─── 加购表单 ──────────────────────────────── */
  var form = document.querySelector('.cpc-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = idInput ? idInput.value : null;
      var qty       = parseInt(qtyInput ? qtyInput.value : 1) || 1;
      if (!variantId) return;

      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding...'; }

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Add to Cart'; }
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          fetch('/?sections=cart-drawer')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data['cart-drawer']) {
                var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
                var nd  = doc.querySelector('cart-drawer');
                if (nd) drawer.innerHTML = nd.innerHTML;
              }
              if (typeof drawer.open === 'function') drawer.open();
            });
        } else {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
        }
      })
      .catch(function (err) {
        console.error(err);
        if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Add to Cart'; }
      });
    });
  }

  /* ─── 立即购买 ──────────────────────────────── */
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      var variantId = idInput ? idInput.value : null;
      var qty       = parseInt(qtyInput ? qtyInput.value : 1) || 1;
      if (!variantId) return;
      this.disabled    = true;
      this.textContent = 'Processing...';
      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) {
        console.error(err);
        buyNowBtn.disabled    = false;
        buyNowBtn.textContent = 'Buy It Now';
      });
    });
  }

  /* ─── 初始化 ────────────────────────────────── */
  updateVariant();
});
/* ── 视频区域：滚动进入视口自动播放第一个视频 ── */
(function () {
  function initVideoAutoplay() {
    const videosWrap = document.querySelector('.cpc-videos');
    if (!videosWrap) return;

    // 取第一个 video 元素
    const firstVideo = videosWrap.querySelector('video');
    if (!firstVideo) return;

    // 确保静音才能自动播放（浏览器策略）
    firstVideo.muted = true;
    firstVideo.playsInline = true;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            firstVideo.play().catch(() => {
              // 部分浏览器限制，静默忽略
            });
            // 播放一次后停止观察
            observer.unobserve(videosWrap);
          }
        });
      },
      {
        threshold: 0.3 // 视频区域露出 30% 时触发
      }
    );

    observer.observe(videosWrap);
  }

  // DOM 加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoAutoplay);
  } else {
    initVideoAutoplay();
  }
})();
/* ── 视频区域：滚动进入视口自动播放第一个视频 ── */
(function () {
  function initVideoAutoplay() {
    const videosWrap = document.querySelector('.cpc-videos');
    if (!videosWrap) return;

    const firstVideo = videosWrap.querySelector('video');
    if (!firstVideo) return;

    firstVideo.muted = true;
    firstVideo.playsInline = true;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            firstVideo.play().catch(() => {});
            observer.unobserve(videosWrap);
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(videosWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoAutoplay);
  } else {
    initVideoAutoplay();
  }
})();

/* ── 点击视频：左下角浮动播放器 ── */
(function () {
  // 注入浮动播放器 HTML + CSS
  function injectFloatPlayer() {
    if (document.getElementById('cpc-float-player')) return;

    // CSS
    const style = document.createElement('style');
    style.textContent = `
      #cpc-float-player {
        display: none;
        position: fixed;
        bottom: 24px;
        left: 24px;
        width: 180px;
        aspect-ratio: 9 / 16;
        background: #000;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 8px 32px rgba(0,0,0,0.45);
        z-index: 99999;
      }
      #cpc-float-player.is-open {
        display: block;
      }
      #cpc-float-player video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
      #cpc-float-close {
        position: absolute;
        top: 6px;
        right: 8px;
        width: 24px;
        height: 24px;
        background: rgba(0,0,0,0.55);
        border: none;
        border-radius: 50%;
        color: #fff;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        cursor: pointer;
        z-index: 1;
        padding: 0;
      }
      #cpc-float-unmute {
        position: absolute;
        bottom: 8px;
        left: 8px;
        background: rgba(0,0,0,0.55);
        border: none;
        border-radius: 20px;
        color: #fff;
        font-size: 11px;
        padding: 3px 8px;
        cursor: pointer;
        z-index: 1;
      }

      /* 移动端：右下角，稍小 */
      @media screen and (max-width: 749px) {
        #cpc-float-player {
          width: 130px;
          bottom: 16px;
          left: 16px;
        }
      }
    `;
    document.head.appendChild(style);

    // HTML
    const wrap = document.createElement('div');
    wrap.id = 'cpc-float-player';
    wrap.innerHTML = `
      <button id="cpc-float-close" aria-label="关闭">✕</button>
      <video id="cpc-float-video" playsinline controls></video>
      <button id="cpc-float-unmute" aria-label="取消静音">🔇 点击开声</button>
    `;
    document.body.appendChild(wrap);

    // 关闭按钮
    document.getElementById('cpc-float-close').addEventListener('click', function () {
      closeFloatPlayer();
    });

    // 取消静音按钮
    const unmuteBtn = document.getElementById('cpc-float-unmute');
    const floatVideo = document.getElementById('cpc-float-video');
    unmuteBtn.addEventListener('click', function () {
      floatVideo.muted = false;
      unmuteBtn.style.display = 'none';
    });

    // 视频取消静音后隐藏按钮
    floatVideo.addEventListener('volumechange', function () {
      unmuteBtn.style.display = floatVideo.muted ? 'block' : 'none';
    });
  }

  function openFloatPlayer(srcVideo) {
    const wrap = document.getElementById('cpc-float-player');
    const floatVideo = document.getElementById('cpc-float-video');
    const unmuteBtn = document.getElementById('cpc-float-unmute');

    // 暂停原视频
    srcVideo.pause();

    // 同步 src
    floatVideo.src = srcVideo.currentSrc || srcVideo.querySelector('source')?.src || '';
    floatVideo.currentTime = srcVideo.currentTime;
    floatVideo.muted = true;
    floatVideo.loop = true;

    // 重置静音提示
    unmuteBtn.style.display = 'block';

    wrap.classList.add('is-open');
    floatVideo.play().catch(() => {});
  }

  function closeFloatPlayer() {
    const wrap = document.getElementById('cpc-float-player');
    const floatVideo = document.getElementById('cpc-float-video');
    floatVideo.pause();
    floatVideo.src = '';
    wrap.classList.remove('is-open');
  }

  function initFloatPlayer() {
    injectFloatPlayer();

    const videosWrap = document.querySelector('.cpc-videos');
    if (!videosWrap) return;

    const videos = videosWrap.querySelectorAll('video');
    videos.forEach(function (video) {
      video.addEventListener('click', function (e) {
        // 如果已经在浮动播放器里，不重复触发
        if (video.closest('#cpc-float-player')) return;
        e.preventDefault();
        openFloatPlayer(video);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatPlayer);
  } else {
    initFloatPlayer();
  }
})();